import { Input } from '@ui-components/neo.tax';

import { ValueInputType } from './types';

export const StringValueInput: ValueInputType = ({ onChange, value }): React.ReactElement => (
  <Input
    value={value ?? ''}
    onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
      onChange(e.target.value);
    }}
  />
);
